import axios from 'axios';

const CONCURRENT_UPLOADS = 4;
const CHUNK_SIZE = 1048576;
const genericFunc = () => {
};

function _arrayBufferToBase64( buffer ) {
  let binary = '';
  const bytes = new Uint8Array( buffer );
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode( bytes[ i ] );
  }
  return window.btoa( binary );
}

class Upload {
  constructor(file, onStart, onProgress) {
    this.fileReady = new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => {
        this.arrayBuffer = reader.result;
        resolve();
      };
      reader.readAsArrayBuffer(file);
    });
    if (file) {
      this.filename = file.name;
      this.fileType = file.type;
      this.onStart = onStart || genericFunc;
      this.onProgress = onProgress || genericFunc;
    }
  }

  upload() {
    return new Promise((resolve) => {
      this.fileReady.then(() => {
        this.doUpload().then(resolve);
      });
    });
  }

  getBase64() {
    return new Promise((resolve) => {
      this.fileReady.then(() => {
        const b64 = _arrayBufferToBase64(this.arrayBuffer)
        resolve(b64);
      });
    });
  }

  async uploadPiece(index) {
    const slice = this.arrayBuffer.slice(index * CHUNK_SIZE, (index + 1) * CHUNK_SIZE);
    const blob = new Blob([new Uint8Array(slice)], { type: this.fileType });
    const form = new FormData();
    form.append('slice', blob, `${this.uuid}.${index + 1}.${this.filename.split('.').reverse()[0]}`);

    try {
      await axios.patch('/api/uploads', form);
      this.numDone++;
      this.onProgress(this.numDone, this.numPieces, this.uuid);
      return index;
    } catch (error) {
      return this.uploadPiece(index);
    }
  }

  async doUpload() {
    this.numPieces = Math.ceil(this.arrayBuffer.byteLength / CHUNK_SIZE);
    this.numDone = 0;

    try {
      const response = await axios.post('/api/uploads', {
        filename: this.filename,
        pieces: this.numPieces,
        type: this.fileType,
        client_schema: window.CLIENT_SCHEMA
      });

      this.uuid = response.data.uuid;
      this.onStart(this.numPieces, response.data.uuid);

      // Start uploading from index 0
      await this.uploadBatch(0);
    } catch (error) {
      throw error;
    }
  }

  async uploadBatch(startIndex) {
    const endIndex = Math.min(startIndex + CONCURRENT_UPLOADS, this.numPieces);
    const uploadPromises = [];

    const indices = Array.from({ length: endIndex - startIndex }, (_, i) => startIndex + i);

    for (const index of indices) {
      uploadPromises.push(this.uploadPiece(index));
    }

    await Promise.all(uploadPromises);

    if (endIndex < this.numPieces) {
      return this.uploadBatch(endIndex);
    }
  }
}

export default Upload;